const TestsActions = {
  START_LOADING: 'START_LOADING',
  END_LOADING: 'END_LOADING',
  LOAD_MCQ_CHALLENGES_SUCCESS: 'LOAD_MCQ_CHALLENGES_SUCCESS',
  LOAD_MCQ_CHALLENGES_SUCCESSV1: 'LOAD_MCQ_CHALLENGES_SUCCESSV1',
  LOAD_MCQ_CHALLENGES_SUCCESSV2: 'LOAD_MCQ_CHALLENGES_SUCCESSV2',
  LOAD_TAGS_MCQ_FILTER_SUCCESS: 'LOAD_TAGS_MCQ_FILTER_SUCCESS',
  START_WORK_EXP_MCQ_LOADING: 'START_WORK_EXP_MCQ_LOADING',
  END_WORK_EXP_MCQ_LOADING: 'END_WORK_EXP_MCQ_LOADING',
  LOAD_WORK_EXP_MCQ: 'LOAD_WORK_EXP_MCQ',
  GET_SENIORIY_LEVEL: 'GET_SENIORIY_LEVEL',
  REMOVE_SENIORITY_LEVEL: 'REMOVE_SENIORITY_LEVEL',
  CLOSE_WORK_EXP_MODAL: 'CLOSE_WORK_EXP_MODAL',
  HIDE_TECHLEAD_MODAL: 'HIDE_TECHLEAD_MODAL',
  HIDE_TECHLEAD_ONE_TEST_LEFT_MODAL: 'HIDE_TECHLEAD_ONE_TEST_LEFT_MODAL',
  LOAD_PROFILE_COMPLETE_STATUS: 'LOAD_PROFILE_COMPLETE_STATUS',
  HIDE_TECHLEAD_NEXTSTACK_MODEL: 'HIDE_TECHLEAD_NEXTSTACK_MODEL',
  RESET_DATA: 'RESET_DATA'
};

const MCQ_GROUPS = {
  TAKE_ONE: 'TAKE_ONE',
  TAKE_ALL: 'TAKE_ALL',
  INTERESTED: 'INTERESTED',
  IN_PROGRESS: 'IN_PROGRESS',
  OTHER: 'OTHER'
};

const TestState = {
  TODO: 'TODO',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS'
};

export {
  TestsActions,
  MCQ_GROUPS,
  TestState
};
